var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 430,
    viewBox: "0 0 290 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.71573 0 0 6.71574 0 15V415C0 423.284 6.71573 430 15 430H275C283.284 430 290 423.284 290 415V15C290 6.71573 283.284 0 275 0H15ZM53 63C46.9249 63 42 67.9249 42 74V355C42 361.075 46.9249 366 53 366H238C244.075 366 249 361.075 249 355V74C249 67.9249 244.075 63 238 63H53Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 390C42 383.925 46.9249 379 53 379H238C244.075 379 249 383.925 249 390V416C249 416.552 248.552 417 248 417H43C42.4477 417 42 416.552 42 416V390Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 403C13 400.239 15.2386 398 18 398H32C34.7614 398 37 400.239 37 403V416C37 416.552 36.5523 417 36 417H14C13.4477 417 13 416.552 13 416V403Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254 403C254 400.239 256.239 398 259 398H273C275.761 398 278 400.239 278 403V416C278 416.552 277.552 417 277 417H255C254.448 417 254 416.552 254 416V403Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 373,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 373,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 348,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 348,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 322,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 322,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 296,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 296,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 270,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 270,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 245,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 245,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 219,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 219,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 193,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 193,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 167,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 167,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 142,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 142,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 116,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 116,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 90,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 90,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 64,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 64,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 39,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 39,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#343434",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 13.4477 13.4477 13 14 13H36C36.5523 13 37 13.4477 37 14V27C37 29.7614 34.7614 32 32 32H18C15.2386 32 13 29.7614 13 27V14Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254 14C254 13.4477 254.448 13 255 13H277C277.552 13 278 13.4477 278 14V27C278 29.7614 275.761 32 273 32H259C256.239 32 254 29.7614 254 27V14Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14C42 13.4477 42.4477 13 43 13H248C248.552 13 249 13.4477 249 14V39C249 45.0751 244.075 50 238 50H53C46.9249 50 42 45.0751 42 39V14Z",
    fill: "#343434",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout5);
export default __webpack_public_path__ + "static/media/layout5.2c81b167f4983bd49ea45505347f8f99.svg";
export { ForwardRef as ReactComponent };